import flat from './flat'
import { wishUrl } from './const'

/**
 * get_activity_info
 */
export const getWishActInfo = () => {
  return flat(`${wishUrl}/get_activity_info`)
}
///api/mall/proxy/wishchallenge/get_sell_page_info

export const getSellPageInfo = () => {
  return flat(`${wishUrl}/get_sell_page_info`)
}

//
export const getCartInfo = () => {
  return flat(`${wishUrl}/get_shop_cart_info`)
}

///api/mall/proxy/wishchallenge/modify_shop_cart_goods
export const changeCartNumber = (subItemId, count = 1) => {
  return flat(`${wishUrl}/modify_shop_cart_goods`, {
    method: 'POST',
    body: {
      subItemId,
      count,
    },
  })
}
//batch_modify_shop_cart_goods
export const batchChangeCartNumber = (arr = []) => {
  return flat(`${wishUrl}/batch_modify_shop_cart_goods`, {
    method: 'POST',
    body: arr,
  })
}
///api/mall/proxy/wishchallenge/remove_shop_cart_goods
export const delCartItem = subItemIds => {
  return flat(`${wishUrl}/remove_shop_cart_goods`, {
    method: 'POST',
    body: {
      subItemIds,
    },
  })
}

export const signUp = () => {
  return flat(`${wishUrl}/sign_up`, {
    method: 'POST',
  })
}
